import React from 'react'
import { Card, Flex, Typography } from 'antd'
import {
  InHold,
  LocalBalance,
} from '../../../../../views/widgets/walletCard/types'
import { getFinsystemNumberFormat } from '../../../../../libs/utils'

type Props = {
  showInHold: boolean
  inHold: InHold
  overallBalanceUsd: number | null
  localBalances: LocalBalance[]
}
export const BalanceCardDetails: React.FC<Props> = ({
  showInHold,
  inHold,
  overallBalanceUsd,
  localBalances,
}) => {
  if (typeof overallBalanceUsd === 'undefined') {
    return null
  }

  return (
    <Card style={{ fontSize: '24px', height: 300 }}>
      <Typography.Title level={3}>Balance</Typography.Title>
      <Flex gap={45}>
        <Flex
          vertical
          wrap="nowrap"
          style={{
            flexGrow: '1',
            minWidth: '180px',
          }}
        >
          <Typography.Text type="secondary" style={{ fontSize: '18px' }}>
            Total sum
          </Typography.Text>
          <Flex gap={8} className={'mb-3'}>
            <Typography.Title level={2} style={{ margin: 0 }}>
              {Math.floor(
                overallBalanceUsd ? overallBalanceUsd : 0,
              )?.toLocaleString('ru')}
            </Typography.Title>
            <Typography.Title level={2} style={{ margin: 0 }} type="secondary">
              USD
            </Typography.Title>
          </Flex>
          {showInHold && (
            <>
              <Typography.Text type="secondary" style={{ fontSize: '18px' }}>
                In hold
              </Typography.Text>
              <Flex gap={8}>
                <Typography.Title level={2} style={{ margin: 0 }}>
                  {inHold.total ? inHold.total : 0}
                </Typography.Title>
                <Typography.Title
                  level={2}
                  style={{ margin: 0 }}
                  type="secondary"
                >
                  USD
                </Typography.Title>
              </Flex>
            </>
          )}
        </Flex>
        <Flex
          className="customScroll"
          style={{
            overflowX: 'scroll',
            flexGrow: '1',
          }}
          gap={20}
          wrap="nowrap"
        >
          {localBalances?.map((item) => (
            <Flex
              vertical
              gap={24}
              key={item.currency}
              style={{ flex: '0 0 140px' }}
            >
              <Flex vertical>
                <Typography.Text style={{ fontSize: '18px' }} type="secondary">
                  {`Balance in ${item.currency}`}
                </Typography.Text>
                <Typography.Text style={{ margin: 0, fontSize: '18px' }}>
                  {getFinsystemNumberFormat(item.sum, 8)}
                </Typography.Text>
              </Flex>
              <Flex vertical>
                <Typography.Text type="secondary" style={{ fontSize: '18px' }}>
                  {`${item.currency} in USD`}
                </Typography.Text>
                <Typography.Text
                  style={{
                    margin: 0,
                    fontSize: '18px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {getFinsystemNumberFormat(item.sumUSD, 2)}
                </Typography.Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Card>
  )
}
